export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading text-background-50">黑桃视频</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50 max-w-xs">
              西瓜视频免费、西瓜视频高清全集在线观看平台。
              每日更新最新电视剧电影大全，不缓冲流畅播放，
              为你带来极致的在线影视体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '热门推荐', id: '#carousel' },
                { label: '专题合集', id: '#index' },
                { label: '热播榜单', id: '#ranking' },
                { label: '最新动态', id: '#updates' },
              ].map((item) => (
                <li key={item.id}>
                  <a
                    href={item.id}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.id);
                    }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50 mb-4">内容频道</h3>
            <ul className="space-y-2.5">
              {['热播电视剧', '高分电影', '热门综艺', '动漫番剧', '纪录片库'].map((item) => (
                <li key={item}>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo('#cards');
                    }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/40 leading-relaxed">
              黑桃视频精选聚合多家优质影视平台资源，持续拓展内容合作，为影迷提供更丰富的观影选择。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 黑桃视频 · 西瓜视频免费与西瓜视频高清全集在线观看不缓冲电影大全
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#hero');
              }}
              className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
            >
              回到顶部
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#contact');
              }}
              className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
            >
              联系我们
            </a>
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#faq');
              }}
              className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
            >
              常见问题
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}